import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initAnalytics } from './lib/analytics';
import { queryClient } from './lib/queryClient';
import './styles/globals.css';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    integrations: [Sentry.browserTracingIntegration()],
  });
}

initAnalytics();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<CrashScreen />}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);

function CrashScreen() {
  return (
    <div className="mx-auto max-w-md px-4 pt-10 text-center space-y-3">
      <div className="font-display text-3xl uppercase text-trophy-gold">Whoops.</div>
      <p className="text-text-dim text-sm">
        Something broke. Our team's been told. Try reopening the app from @PunditXIBot.
      </p>
    </div>
  );
}
